/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_CONTENTS_DETAILS_REQUEST,
  FETCH_CONTENTS_DETAILS_SUCCESS,
  FETCH_CONTENTS_DETAILS_FAILURE,
  FETCH_DOMAIN_APPROVER_CONTENTS_REQUEST,
  FETCH_DOMAIN_APPROVER_CONTENTS_SUCCESS,
  FETCH_DOMAIN_APPROVER_CONTENTS_FAILURE,
} from "./ContentsDetailsTypes";

  const initialState = {
    loading: false,
    error: "",
    contentDetails:{
      portfolioContents: [],
      groupAppsCount: {}, // Initialize as an empty object
      thirdPartyAppsCount: {}, // Initialize as an empty object
    },
    domainApproverContents: [], // Add domain approver contents
    domainApproverLoading: false, // Separate loading state for domain approver
    domainApproverError: "", // Separate error state for domain approver
  };
  
  const ContentsDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CONTENTS_DETAILS_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case FETCH_CONTENTS_DETAILS_SUCCESS:
        return {
          loading: false,
          contentDetails: {
            ...state.contentDetails,
            ...action.payload, // Merge the existing state with the new data
          },
          error: "",
        };
      case FETCH_CONTENTS_DETAILS_FAILURE:
        return {
          loading: false,
          contentDetails: {},
          error: action.payload,
        };
      
      // Domain Approver Contents Cases
      case FETCH_DOMAIN_APPROVER_CONTENTS_REQUEST:
        return {
          ...state,
          domainApproverLoading: true,
          domainApproverError: "",
        };

      case FETCH_DOMAIN_APPROVER_CONTENTS_SUCCESS:
        return {
          ...state,
          domainApproverLoading: false,
          domainApproverContents: action.payload,
          domainApproverError: "",
        };

      case FETCH_DOMAIN_APPROVER_CONTENTS_FAILURE:
        return {
          ...state,
          domainApproverLoading: false,
          domainApproverContents: [],
          domainApproverError: action.payload,
        };
        
      default:
        return state;
    }
  };
  
  export default ContentsDetailsReducer;
  